import {ArrowRight} from 'lucide-react';
import './MoreHub.css';
import TransparentCharacterImage from './TransparentCharacterImage';

export type MoreSection='Activity Log'|'Guardrails'|'Connections'|'Settings'|'Profile'|'Notes'|'Toolbox'|'Agent Chats'|'Skills';

const ITEMS:{id:MoreSection;image:string}[]=[
 {id:'Skills',image:'skills'},
 {id:'Activity Log',image:'activity-log'},
 {id:'Guardrails',image:'guardrails'},
 {id:'Connections',image:'connections'},
 {id:'Settings',image:'settings'},
 {id:'Profile',image:'settings'},
 {id:'Notes',image:'notes'},
 {id:'Toolbox',image:'toolbox'},
 {id:'Agent Chats',image:'agent-chats'}
];

const ARTWORK: Record<string,string> = {
 skills:'/assets/agentordinary/features/skills.webp',
 'activity-log':'/assets/agentordinary/features/activity.webp',
 guardrails:'/assets/agentordinary/features/guardrail.webp',
 connections:'/assets/agentordinary/features/connections.webp',
 settings:'/assets/agentordinary/features/settings.webp',
 notes:'/assets/agentordinary/features/tasks.webp',
 toolbox:'/assets/agentordinary/features/tasks.webp',
 'agent-chats':'/assets/agentordinary/more/agent-chats.webp'
};

export default function MoreHub({onSelect}:{onSelect:(name:MoreSection)=>void}){
 return <section className="more-hub" aria-label="More">
  <h1>More</h1>
  <div className="more-hub-grid">
   {ITEMS.map(({id,image})=><button className="more-hub-tile" type="button" key={id} onClick={()=>onSelect(id)}>
    <span className="more-hub-image"><TransparentCharacterImage src={ARTWORK[image]} alt="" width="80" height="80" loading="lazy" draggable={false}/></span>
    <span className="more-hub-label">{id}</span><ArrowRight size={18} className="more-hub-arrow" aria-hidden="true"/>
   </button>)}
  </div>
 </section>;
}
